import classNames from 'classnames';

type Props = {
    backgroundsurface?: SupportedBackgroundColor;
};

const PersonalCodeDisclaimer = ({ backgroundsurface = 'bg-surface-100' }: Props) => {
    return (
        <section className={classNames('px-4 py-6 lg:py-12', backgroundsurface)}>
            <div className="max-w-1200 mx-auto">
                <p>
                    <sup>1</sup> Top plans based on Kaiser Family Foundation&apos;s&nbsp;
                    <a
                        className="font-bold text-primary"
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.kff.org/medicare/issue-brief/medicare-advantage-in-2022-enrollment-update-and-key-trends/"
                    >
                        2023 Update and Key Trends report
                    </a>
                    ; analysis of 2023 CMS Medicare Advantage enrollment by firm.
                </p>
                <p>
                    * This ad is not from the government. It&apos;s from eHealth, an insurance
                    agency selling plans from many insurance companies.
                </p>
                <p className="mt-4 text-center">Last Updated Date: 10/26/2023 | MMR-1104-2023</p>
            </div>
        </section>
    );
};

export default PersonalCodeDisclaimer;
